"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.SystemCreate;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.systemId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.i);
    messageWriter_sidecar_1.messageWriter.write16(m, d.j);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.key);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        systemId: messageWriter_sidecar_1.messageWriter.read32(m),
        i: messageWriter_sidecar_1.messageWriter.read16(m),
        j: messageWriter_sidecar_1.messageWriter.read16(m),
        key: messageWriter_sidecar_1.messageWriter.readString(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        systemId: 100,
        key: 'med-123',
        i: 7,
        j: 8,
    };
    messageWriter_sidecar_1.messageWriter.test('system-create', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    voyageTilemap_sidecar_1.voyageTilemap.networkAddSystem(msg);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
